import axios from "axios";
import { toast } from "sonner";
import { LOCAL_STORAGE_KEYS } from "src/components/Types";

let tokenName = "ADAPTCLOUDOPS_APN_PARTNERSHIP_TOKEN";

let BASE_PATH: string = "";
if (process.env.REACT_APP_NODE_ENV === "development") {
  console.log(process.env.REACT_APP_NODE_ENV);
  BASE_PATH = process.env.REACT_APP_DEV_URL!;
} else {
  BASE_PATH = process.env.REACT_APP_PROD_URL!;
}

const unSecuredRoutes = [
  "/authentication/send-otp",
  "/authentication/verify-otp",
  "/authentication/login",
  "/authentication/signup",
];

// Create Axios instance with common config
const axiosInstance = axios.create({
  baseURL: BASE_PATH,
  headers: {
    "Content-Type": "application/json",
  },
});

// Request Interceptor for Authorization
axiosInstance.interceptors.request.use(
  (config) => {
    const Authorization =
      !unSecuredRoutes.includes(config.url!)
        ? `Bearer ${getLocalData(LOCAL_STORAGE_KEYS.ADAPTCLOUDOPS_APN_PARTNERSHIP_TOKEN)}`
        : "";
    config.headers["Authorization"] = Authorization;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response Interceptor for error handling
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const res = error.response;
    if (res) {
      if (res.status === 400) {
        toast.error(res?.data?.errorMessage || 'Something went wrong, Please try again later!');
      }
      if (res.status === 401) {
        toast.error("Please Login again!!");
        removeLocalData();
      }
      if (res.status === 403) {
        throw new Error("Forbidden");
      }
      if (res.status === 500) {
        toast.error("Server Error, Try again later!");
      }
    }
    return Promise.reject(error);
  }
);

export function removeLocalData() {
  window.localStorage.removeItem(LOCAL_STORAGE_KEYS.ADAPTCLOUDOPS_APN_PARTNERSHIP_TOKEN);
  window.localStorage.removeItem(LOCAL_STORAGE_KEYS.ADAPTCLOUDOPS_APN_PARTNERSHIP);
  window.location.href = "/login";

}

function getLocalData(tokenName: LOCAL_STORAGE_KEYS) {
  const getItem = localStorage.getItem(tokenName);
  return getItem ? JSON.parse(getItem).token : null;
}

export const apiGet = async (url: string): Promise<any> => {
  try {
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    console.error("An Error occurred ", error);
    throw error;
  }
};

export const apiPost = async (url: string, data: any): Promise<any> => {
  try {
    const response = await axiosInstance.post(url, data);
    return response.data;
  } catch (error:any) {
    console.error("An Error occurred ", error);
    if (error && error.response && error.response.status === 400) {
      throw new Error("Bad Request");
    }
    throw error;
  }
};

export const apiPut = async (url: string, data: any): Promise<any> => {
  try {
    const response = await axiosInstance.put(url, data);
    return response.data;
  } catch (error) {
    console.error("An Error occurred ", error);
    throw error;
  }
};

export const apiDelete = async (url: string): Promise<any> => {
  try {
    const response = await axiosInstance.delete(url);
    return response.data;
  } catch (error) {
    console.error("An Error occurred ", error);
    throw error;
  }
};

export const apiPostImage = async (url: string, data: any): Promise<any> => {
  try {
    const response = await axiosInstance.post(url, data, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  } catch (error) {
    console.error("An Error occurred when uploading image", error);
    throw error;
  }
};
